import * as React from 'react';
import { usePerformAction } from 'react-remote-data-hooks';
import api from '../../../../api';
import { PreBookingSettings } from '../../../../core';
import { useAppSettings } from '../../../../core/hooks/useAppSettings';
import UpdateForm from './UpdateForm';

interface IPreBookingSettingsProps {
  data?: PreBookingSettings;
  reload?: () => void;
}

const PreBookingSettingsTab: React.FunctionComponent<IPreBookingSettingsProps> = (
  props
) => {
  const appSettings = useAppSettings(api.settings);
  const [editModalOpen, setEditModalOpen] = React.useState(false);

  const {
    performAction: update,
    error: updateError,
    isPerforming: updating,
  } = usePerformAction(
    (data: PreBookingSettings) =>
      api.settings.updatePreBookingSettings({
        ...data,
        expiry: { ...data.expiry, value: Number(data.expiry.value) },
        campaignDifferentiatorTimeline: data.campaignDifferentiatorTimeline?{ ...data.campaignDifferentiatorTimeline, value: Number(data.campaignDifferentiatorTimeline.value) }:undefined,
      }),
    () => {
      props.reload?.();
      setEditModalOpen(false);
      appSettings.reload();
    }
  );

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">Pre-Booking Settings</h4>
          </div>
          <div className="col-auto text-right">
            <button
              className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center"
              onClick={() => setEditModalOpen(true)}
            >
              <i className="icon-edit mr-1 font-xs"></i> Edit
            </button>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">Name</span>
                </th>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Value
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Pre-Booking Expiry</td>
                <td>
                  {props.data?.expiry?.value} {props.data?.expiry?.unit}
                </td>
              </tr>
              <tr>
                <td>Same Calendar Month Option Enabled</td>
                <td>
                  {props.data?.sameCalendarMonthOptionEnabled?"Yes": "No"}
                </td>
              </tr>
              <tr>
                <td>Campaign Differentiator Timeline</td>
                <td>
                  {props.data?.campaignDifferentiatorTimeline?.value} {props.data?.campaignDifferentiatorTimeline?.unit}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModalOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <UpdateForm
              onSubmit={(formData) => update(formData)}
              isSubmitting={updating}
              error={updateError?.message}
              data={props.data}
              onCancel={() => setEditModalOpen(false)}
            ></UpdateForm>
          </>
        )}
      </div>
    </>
  );
};

export default PreBookingSettingsTab;
